import { render } from "./LayoutFullWidth.vue?vue&type=template&id=232487e6"
import script from "./LayoutFullWidth.vue?vue&type=script&lang=js"
export * from "./LayoutFullWidth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__